import React, { Component } from 'react'

export default class VolLine extends Component {
    render() {

        const {vol, dates, horaires, depart, departCode, arrive, arriveCode, escale,duree,flight_no,volclass} = this.props
        
        let fare_category;
        switch (volclass) {
          case "M":
            fare_category = <span className="badge eco py-2">Economy</span>
            break;
          case "C":
            fare_category = <span className="badge eco py-2">Business</span>
            break;
          case "F":
            fare_category = <span className="badge eco py-2">First class</span>
            break;
          default:
            break;
        }
        const escales = this.props.escalejd.toString().slice(1,this.props.escalejd.length)
        return (
            <>
            <div className="container">
                <div className="d-flex justify-content-between">

                  <div className="d-flex flex-column col-3">
                    {vol.carrierCode !== "" && (
                      <img
                        className="d-flex"
                        src={`https://daisycon.io/images/airline/?width=500&height=150&color=ffffff&iata=${vol.carrierCode}`}
                        style={{width:"80px"}}
                      />
                    )}
                    {vol.carrierCode === "" && <span>Multiple airlines</span>}

                    <div className="d-flex flex-column align-items-center">
                      <span className="opacity__tx  d-flex">Vol N°{flight_no}</span>
                      <span className="d-flex" style={{ fontSize: "14px" }}>{vol.companyName}</span>
                    </div>

                   {fare_category}
                  </div>

                  <div className="d-flex flex-column align-items-center  col-3">
                  <div className="d-flex"
                        style={{ fontSize: "13px"}}
                      >{dates[0]}</div>
                    <div
                      className="d-flex"
                      style={{ fontSize: "16px", fontWeight: "bold" }}
                    >
                      {horaires[0]}
                    </div>
                    <span className="d-flex" style={{ fontSize: "13px" }}>
                      {this.props.citiesName[0]} ({departCode})
                    </span>
                  </div>

                  <div className="d-flex flex-column  align-items-center  col-3">
                    <span
                      data-toggle="tooltip"
                      data-placement="left"
                      title="Tooltip on right"
                    >
                    </span>
                    {duree}
                      {escales.length ===0 && <div className="badge direct py-2 px-3">Direct</div>}
                      {escales.length !==0 && <div className="badge stop py-2  px-3">{escales.split(',').length} Stop</div>}
                      {this.props.escalejd.toString().slice(1,this.props.escalejd.length)}

                  </div>

                  <div className="d-flex  flex-column align-items-center col-3">
                  <div className="d-flex"
                        style={{ fontSize: "13px"}}
                      >{dates[1]}</div>
                    <div
                      className="d-flex"
                      style={{ fontSize: "16px", fontWeight: "bold" }}
                    >
                      {horaires[1]}
                    </div>
                    <span className="d-flex" style={{ fontSize: "13px" }}>
                      {this.props.citiesName[1]} ({arriveCode})
                    </span>
                  </div>
                </div>
              </div>
            </>
        )
    }
}
